export const HELP_CENTER_ERROR_TYPE = {
  invalidProblem: '/errors/invalid-problem',
} as const
